import './SavingsBanner.css';


const SavingsBanner = () => {

  return (
    
    <div className="sc-calculator-container">

      <div className="sc-top-banner">
        <div className="sc-banner-text">
          <p>
          Enhance your HVAC system to substantially lower energy usage, shrink your carbon footprint, and reduce electricity expenses—all without any upfront costs or operational downtime.
          </p>
          <p>
          Use our Savings Calculator* to estimate your potential savings by entering your property details below. We’re dedicated to helping you create a more sustainable building while minimizing environmental impact.
          </p>
          <p className="disclaimer">
          *Please note: The energy savings estimates are based on standard assumptions and may not fully reflect the unique conditions of your property. For a more precise, tailored assessment, please do not hesitate to contact us.
          </p>
        </div>
      </div>
      <h1 className="sc-title">
        Chiller Energy <span>savings calculator</span>
      </h1>
    </div>
  );
};

export default SavingsBanner;
